"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSummaryFlow = void 0;
var _react = require("react");
var _useRecommendationStatus = require("../recommendation/useRecommendationStatus");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _reactRedux = require("react-redux");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useUserSessionStatus2 = require("../user/useUserSessionStatus");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _uiActions = require("../../store/ui/uiActions");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useSummaryFlow = function useSummaryFlow() {
  var _config$summaryPageDu;
  var dispatch = (0, _reactRedux.useDispatch)();
  var config = (0, _reactRedux.useSelector)(_widgetSelectors.selectConfig);
  var summaryPageDuration = ((_config$summaryPageDu = config.summaryPageDuration) !== null && _config$summaryPageDu !== void 0 ? _config$summaryPageDu : 4) * 1000;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldStartSummaryFlow = _useState2[0],
    setShouldStartSummaryFlow = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSummaryFinished = _useState4[0],
    setIsSummaryFinished = _useState4[1];
  var _useRecommendationSta = (0, _useRecommendationStatus.useRecommendationStatus)(),
    isRecommendationFetched = _useRecommendationSta.isRecommendationFetched,
    isJourneyForObject = _useRecommendationSta.isJourneyForObject,
    isRecommendationEmpty = _useRecommendationSta.isRecommendationEmpty;
  var _useUserSessionStatus = (0, _useUserSessionStatus2.useUserSessionStatus)(),
    isSavingUserSession = _useUserSessionStatus.isSavingUserSession;
  var shouldFetchRecommendation = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectIsBudgetAdjusted) || !isRecommendationFetched;
  var shouldEndSummaryFlow = isRecommendationFetched && isSummaryFinished;

  // Step 1:
  // set a flag to start summary flow only after saving user session is finished
  // (from clicking "next" on the previous step)
  (0, _react.useEffect)(function () {
    if (!isSavingUserSession && !shouldStartSummaryFlow) {
      setShouldStartSummaryFlow(true);
    }
  }, [isSavingUserSession]);

  // Step 2:
  // when the summary flow flag is set, fetch the recommendation if needed
  // and start a timer to show the animation.
  (0, _react.useEffect)(function () {
    if (shouldStartSummaryFlow) {
      if (shouldFetchRecommendation) {
        dispatch((0, _recommendationActions.fetchRecommendation)());
      }
      setTimeout(function () {
        setIsSummaryFinished(true);
      }, summaryPageDuration);
    }
  }, [shouldStartSummaryFlow]);

  // Step 3:
  // When both fetching recommendation and animation are finished, signal the end
  // of summary page
  (0, _react.useEffect)(function () {
    if (shouldEndSummaryFlow) {
      if (isRecommendationEmpty) {
        dispatch((0, _uiActions.goToRecommendationErrorPage)(isJourneyForObject));
      } else {
        dispatch((0, _questionnaireActions.endSummary)());
      }
    }
  }, [shouldEndSummaryFlow]);
};
exports.useSummaryFlow = useSummaryFlow;